import { ExamCenterDetailsPageHeader, ExamCenterProvider } from '@exam-center/exam-center-details';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useParams } from '@exam-center/router';
import { Box } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function ExamCenterLayout() {
  const { examCenterCode } = useParams('/:examCenterCode/details');

  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.EXAM_CENTER_MANAGEMENT.EXAM_CENTER.VIEW,
        APP_PERMISSIONS.EXAM_CENTER_MANAGEMENT.MEMBER.VIEW,
        APP_PERMISSIONS.EXAM_CENTER_MANAGEMENT.EXAM_COURSE.VIEW,
      ]}
      options={{ operator: 'OR' }}
    >
      <ExamCenterProvider examCenterCode={examCenterCode}>
        <ExamCenterDetailsPageHeader />
        <Box sx={{ p: (theme) => theme.spacing(6), flex: 1 }}>
          <Outlet />
        </Box>
      </ExamCenterProvider>
    </PermissionGuard>
  );
}
